import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, ViewChild } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';

import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { SearchModel } from '../../search.model';
import { EmptySearchModel } from '@common/empty-search/empty-search.model';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

@Component({
  selector: 'app-search-menu',
  templateUrl: './search-menu.component.html',
  styleUrls: ['./search-menu.component.scss'],
  imports: [ImageLoadingComponent, MatMenu, MatMenuTrigger, FormsModule, FocusRemoverDirective],
  providers: [SearchModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchMenuComponent {
  @ViewChild('menuTrigger') trigger!: MatMenuTrigger;
  @ViewChild('input') input!: ElementRef;

  private destroyRef = inject(DestroyRef);

  constructor(
    public viewModel: SearchModel,
    public emptySearchModel: EmptySearchModel
  ) {}

  onHotKeyword(hotId: string): void {
    this.viewModel.searchProducts(this.destroyRef, true, undefined, hotId, undefined, undefined, true);
    this.trigger.closeMenu();
  }

  onKeyword(keyword: string, setHistory?: boolean): void {
    this.viewModel.searchProducts(this.destroyRef, true, keyword, undefined, undefined, setHistory, true);
    this.trigger.closeMenu();
  }

  onOpen(): void {
    this.input.nativeElement.focus();
  }

  inputChange(value: string, input: HTMLInputElement): void {
    const v = value.replaceAll('%', '');
    input.value = v;
    this.viewModel.keyword.set(v);
  }
}
